import { memo } from 'react';
import { joinNodes } from 'utils/joinNodes';

export const SimpleHierarchy = memo(
    ({ tokens }: { tokens: (string | JSX.Element)[] }) => {
        const lastElemIdx = tokens.length - 1;

        const toSpansWithLastElemBold = (str: string | JSX.Element, idx: number) => (
            <span
                className={
                    tokens.length > 1 && idx === lastElemIdx
                        ? 'text-nowrap bold'
                        : 'text-nowrap'
                }
            >
                {str}
            </span>
        );

        const hierarchyFragments = tokens.map(toSpansWithLastElemBold);

        const elementsToRender = joinNodes(hierarchyFragments, <span> / </span>);

        return <span>{elementsToRender}</span>;
    }
);
